import { colors } from '@chegg-ui/theme'
import { fanta, PrimaryButton } from '@chegg/fanta'

import styled from 'styled-components'
import { smallLayout } from '@chegg-wt/core/theme/theme'
import { AspiraStack } from '@chegg-wt/core/theme/fanta/fonts'

export const Input = styled.input`
  display: block;
  width: 100%;
  height: 44px;
  padding: 6px 12px;
  font-size: 14px;
  font-weight: 100;
  line-height: 1.42857143;
  color: ${({ theme }) => theme.Colors.forFonts.fColor05};
  background-color: #fff;
  background-image: none;
  border: 2px solid #e5e5e5;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  margin-bottom: 16px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  text-overflow: ellipsis;
  &:focus {
    border-color: #0090ff;
    outline: 0;
  }
  &::-moz-placeholder {
    color: ${({ theme }) => theme.Colors.forInterface.interfaceColor22};
    opacity: 1;
  }
  &::-webkit-input-placeholder {
    color: ${({ theme }) => theme.Colors.forInterface.interfaceColor22};
  }
}
`

export const BasicStyleSelect = styled.select`
  height: 44px;
  border: 2px solid #e5e5e5;
  padding: 6px 12px;
  width: 100%;
`

export const CreateButton = styled(PrimaryButton)`
  width: 186px;
  height: 45px;
  margin-left: 5px;
`
export const CreateEditButton = styled(PrimaryButton).attrs({
  isHoverAnimated: true,
  size: 'medium',
})`
  background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor01};
  border-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor01};
  width: 189px;
  &:hover {
    border-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor23};
    background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor23};
    color: #fff;
  }
  @media (min-width: ${({ theme }) => smallLayout(theme)}) {
    margin-left: auto;
  }
`

export const Header1 = styled.h1`
  ${AspiraStack};
  font-size: ${fanta.font.size.xxl};
  font-weight: ${fanta.font.weight.bold};
  color: ${colors.dark};
  line-height: 37px;
  margin: 0px;
  margin-bottom: ${fanta.spacing.sm};
  @media (max-width: ${({ theme }) => smallLayout(theme)}) {
    text-align: center;
  }
`
export const InputLabel = styled.label`
  ${AspiraStack};
  font-size: ${fanta.font.size.xxs};
  font-weight: ${fanta.font.weight.bold};
  line-height: 2;
  color: ${colors.grey};
  margin-top: 0px;
  @media (max-width: ${({ theme }) => smallLayout(theme)}) {
    font-size: ${fanta.font.size.sm};
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const FlexParentMargin = styled.div`
  display: flex;
  margin-top: 20px;
  margin-bottom: 0px;
  align-items: flex-end;
  @media (max-width: ${({ theme }) => smallLayout(theme)}) {
    flex-direction: column;
    align-items: center;
  }
`
